import { inject, Pipe, PipeTransform } from '@angular/core';

import { TranslationStore } from './state/translation.store';

@Pipe({ name: 'translate', pure: false })
export class TranslationPipe implements PipeTransform {
  private store = inject(TranslationStore);

  transform(key: string, params?: Record<string, string | number>) {
    return this.store.translate(key, params);
  }
}
